import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Tooltip } from '@material-ui/core';
import { PlaylistAddCheck as ActionableIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    margin: theme.spacing(2),
    borderRadius: 50,
    minWidth: 36,
    width: 'auto',
    padding: '6px',
    position: 'relative',
  },
  elementHidden: {
    display: 'none',
  },
}));

export default function FilterButton({ onClick, isActive, isHidden }) {
  const classes = useStyles();

  return (
    <>
      <Tooltip title="Toggle Actionable Items">
        <Button
          variant="contained"
          className={clsx(isHidden && classes.elementHidden, classes.submitButton)}
          onClick={onClick}
          color={isActive ? 'secondary' : 'default'}
        >
          <ActionableIcon />
        </Button>
      </Tooltip>
    </>
  );
}
